import archives from './archives'
import money from './money'

export default {
    archives,
    money,
}